<template>
  <div class="wrap">
    <h1 class="common-header">{{ title }}</h1>
    <div class="by-content">
      <div class="quit">
        <!-- 搜索 -->
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <!-- 姓名 -->
          <el-form-item :label="$t('22')">
            <el-input
              class="submitter"
              v-model="form.name"
              :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
            ></el-input>
          </el-form-item>
          <!-- 部门 -->
          <el-form-item :label="$t('27')">
            <department :mprop="{ checkStrictly: true }" :change="departmentHandle"></department>
          </el-form-item>
          <!-- 职位 -->
          <el-form-item :label="$t('24')">
            <job-select v-model="form.job_id" />
          </el-form-item>
          <!-- 员工状态 -->
          <el-form-item :label="$t('31')">
            <el-select v-model="form.state" :placeholder="$t('799')">
              <el-option
                v-for="(item, index) in state"
                :disabled="['1', '4'].includes(item.key)"
                :key="index"
                :label="item.value"
                :value="item.key"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <!-- 入职日期 -->
            <el-form-item :label="$t('28')">
              <el-date-picker
                v-model="form.entryDate"
                type="daterange"
                :start-placeholder="$t('1116')"
                :end-placeholder="$t('1117')"
                value-format="yyyy-MM-dd"
              >
                >
              </el-date-picker>
            </el-form-item>
          </el-form-item>
          <!-- 离职日期 -->
          <el-form-item :label="$t('29')">
            <template slot="label">
              {{ $t('29') }}
              <el-tooltip class="item" effect="dark" :content="$t('i18n.7Y1RdNWcszSG')" placement="top-start">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
            <el-date-picker
              v-model="form.leaveDate"
              type="daterange"
              :start-placeholder="$t('1116')"
              :end-placeholder="$t('1117')"
              value-format="yyyy-MM-dd"
            >
              >
            </el-date-picker>
          </el-form-item>
          <!-- 离职原因 -->
          <el-form-item :label="$t('leave_reason')">
            <el-select v-model="form.reason" :placeholder="$t('221')" clearable>
              <el-option v-for="item in leave_reason" :key="item.code" :label="item.reason" :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 来源 -->
          <el-form-item :label="$t('source')">
            <el-select v-model="form.apply_source" :placeholder="$t('221')" clearable>
              <el-option v-for="(value, key) in source" :key="key" :label="value" :value="key"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <!-- 搜索 -->
            <el-button type="primary" @click="onSubmit(1)">{{ $t('80') }}</el-button>
            <el-button type="primary" @click="onExport" v-if="$p('menu.staff.quit.export')">{{ $t('68') }}</el-button>
          </el-form-item>
        </el-form>
        <!-- 列表 -->
        <div class="table-wrap">
          <el-table :data="tableData" style="width: 100%" v-load="loading" @sort-change="handlerSort">
            <!-- 工号 -->
            <el-table-column prop="staff_code" :label="$t('25')" sortable="custom" width="150" align="center">
            </el-table-column>
            <!-- 姓名 -->
            <el-table-column prop="staff_name" :label="$t('22')" sortable="custom" width="200" align="center">
            </el-table-column>
            <!-- 电话 -->
            <el-table-column prop="mobile" :label="$t('23')" width="200" align="center"> </el-table-column>
            <!-- 部门 -->
            <el-table-column prop="department_name" :label="$t('27')" width="200" align="center"> </el-table-column>
            <!-- 职位 -->
            <el-table-column prop="job_title_name" :label="$t('24')" width="200" align="center"></el-table-column>
            <!-- 员工状态 -->
            <el-table-column prop="state_txt" :label="$t('31')" width="200" align="center"> </el-table-column>
            <!-- 离职日期 -->
            <el-table-column prop="leave_date" sortable="custom" :label="$t('29')" width="200" align="center">
              <template slot="header">
                {{ $t('29') }}
                <el-tooltip class="item" effect="dark" :content="$t('i18n.7Y1RdNWcszSG')" placement="top-start">
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </template>
            </el-table-column>
            <!-- 入职日期 -->
            <el-table-column prop="hire_date" :label="$t('28')" sortable="custom" width="200" align="center">
            </el-table-column>
            <!-- 离职原因 -->
            <el-table-column prop="reason_txt" :label="$t('leave_reason')" width="200" align="center">
            </el-table-column>
            <!-- 来源 -->
            <el-table-column prop="apply_source_txt" :label="$t('source')" width="200" align="center">
              <template slot-scope="scope">
                <!-- App端提交 -->
                <el-button type="text" v-if="scope.row.apply_source === '1'" @click="handlerDetail(scope.row)">{{
                  scope.row.apply_source_txt
                }}</el-button>
                <!-- web端办理 -->
                <span v-else>{{ scope.row.apply_source_txt }}</span>
              </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column :label="$t('70')" align="center" fixed="right">
              <template slot-scope="{ row }">
                <el-dropdown v-if="$p('menu.staff.quit.edit')">
                  <el-button type="text">{{ $t('71') }}</el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <el-button type="text" @click="editLeave(row)">
                        {{ $t('edit_leave') }}
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="row.is_register_user !== 2">
                      <el-button type="text" @click="backInOffice(row)">
                        {{ $t('back_in_office') }}
                      </el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="address" :label="$t('80')"> </el-table-column> -->
          </el-table>
        </div>
        <div class="pagining">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.page"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="page.page_size"
          >
          </el-pagination>
        </div>
        <!-- APP端提交 -->
        <seeComp v-if="isSeeComp" ref="seeComp" />
        <!-- 编辑离职信息 -->
        <edit-leave ref="editLeave" v-if="isEditLeave" @onSubmit="onSubmit(page.page)" />
      </div>
    </div>
  </div>
</template>

<script>
// 部门职位选择组件
import department from '@/components/department'
import jobSelect from '@/components/jobSelect'
// 详情
import seeComp from './../../approval/search/see.vue'
// 编辑离职
import editLeave from './editLeave.vue'
// 接口Api
import { sysInfoFn } from 'api/org/per'
import { configFn } from 'api/approval/search'
import {
  getInit, // 离职原因,来源
  cancelResign,
  exportExcel,
  getResignlist // 离职列表
} from '@/api/org/staff'

// 数据源
const form = () => ({
  hire_date_start: '', // 入职日期
  hire_date_end: '', // 离职日期
  leave_date_start: '', // 离职日期开始
  leave_date_end: '', // 离职日期结束
  name: '', // 打工人name/mobile/code 名字搜索
  department_id: '', // 部门id
  job_id: '', // 职位id
  // entryDate: [], // 入职时间
  // leaveDate: [], // 离职时间
  state: '', // 员工状态
  apply_source: '', // 来源   1-App端提交   2- Web端办理
  reason: '' // 离职原因
})
export default {
  components: {
    department,
    jobSelect,
    seeComp,
    editLeave
  },
  computed: {
    title() {
      try {
        return this.$t(this.$route.meta.title)
      } catch (error) {
        return this.$t('523')
      }
    }
  },
  data() {
    return {
      isSeeComp: false,
      loading: false,
      form: form(),
      tableData: [],
      stateArr: [],
      state: [], // 员工在职状态
      sort: '',
      dir: '',
      page: {
        total: 0,
        page: 1,
        page_size: 100
      },
      isEditLeave: false,
      leave_reason: [], // 离职原因
      source: [], // 来源
      staff_id: ''
    }
  },
  created() {
    this.init()
  },
  methods: {
    // 排序
    handlerSort({ prop, order }) {
      this.sort = prop
      this.dir = order
      this.onSubmit(1)
    },
    init() {
      sysInfoFn().then(res => {
        this.state = res.data.state
      })
      getInit().then(res => {
        this.leave_reason = res.data.reason.reason
        this.source = res.data.apply_source
      })
      this.getConfigFn()
      // 表格数据
      this.onSubmit(1)
    },
    async getConfigFn() {
      const res = await configFn()
      if (res && res.code === 1) {
        this.stateArr = res.data.state
      }
    },
    // 查询
    async onSubmit(val) {
      this.page.page = val
      const { entryDate, leaveDate } = this.form
      this.form.hire_date_start = entryDate ? entryDate[0] : ''
      this.form.hire_date_end = entryDate ? entryDate[1] : ''
      this.form.leave_date_start = leaveDate ? leaveDate[0] : ''
      this.form.leave_date_end = leaveDate ? leaveDate[1] : ''
      const msg = {
        ...this.page,
        ...this.form,
        sort: this.sort,
        dir: this.dir
      }
      this.loading = true
      const res = await getResignlist(msg)
      this.tableData = res.data.body
      this.page.total = res.data.page_data.total
      this.loading = false
    },
    // 导出Excel
    async onExport() {
      const { entryDate, leaveDate } = this.form
      this.form.hire_date_start = entryDate ? entryDate[0] : ''
      this.form.hire_date_end = entryDate ? entryDate[1] : ''
      this.form.leave_date_start = leaveDate ? leaveDate[0] : ''
      this.form.leave_date_end = leaveDate ? leaveDate[1] : ''
      const msg = {
        ...this.page,
        ...this.form,
        sort: this.sort,
        dir: this.dir
      }
      const res = await exportExcel(msg)
      window.location.href = res.data.down_load_excel.object_url
    },
    /**
     * 分页相关
     * @handleSizeChange 分页大小改变
     * @handleCurrentChange 切换页码
     * @departmentHandle 部门选择
     */
    handleSizeChange(v) {
      this.page.page_size = v
      this.onSubmit(1)
    },
    handleCurrentChange(v) {
      this.onSubmit(v)
    },
    departmentHandle(val1, val2) {
      this.form.department_id = val2.slice(-1)[0]
    },
    // 查看详情
    handlerDetail(item) {
      // console.log(ite);
      this.isSeeComp = true
      this.$nextTick(() => {
        this.$set(item, 'audit_id', item.audit_resign_id)
        item.type = 4
        this.$refs.seeComp.init(item)
      })
    },
    // 编辑离职信息
    editLeave(item) {
      const msg = {
        apply_source: item.apply_source,
        staff_id: item.staff_id,
        formal_name: item.formal_txt,
        staff_name: item.staff_name,
        leave_date: item.leave_date,
        leave_reason: item.reason,
        leave_reason_remarks: item.remark,
        hire_date: item.hire_date
      }
      this.isEditLeave = true
      this.$nextTick(() => this.$refs.editLeave.init(msg || null))
    },
    // 恢复在职
    backInOffice(item) {
      this.$confirm(this.$t('2011'), this.$t('229'), {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66')
        // type: 'warning'
      }).then(async () => {
        await cancelResign({ staff_id: item.staff_id })
        this.onSubmit(this.page.page)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wrap {
  border: 1px solid $borderColor;
  padding: 2%;
  margin: 1.5% 0 2% 0;
}
.submitter {
  min-width: 320px;
}
</style>
